export const impressumData = {
  heading: "Impressum",
  sections: [
    {
      title: "Angaben gemäß § 5 TMG",
      content: [
        {
          subtitle: "<strong>Schmeckt Lecker Schnellimbiss</strong>",
          value:
            "Mehmet Karabudak<br />Bahnhofstraße 40<br />59872 Meschede-Freienohl",
        },
      ],
    },
    {
      title: "Kontakt",
      content: [
        {
          subtitle: "Telefon",
          value: "+49 (0) 2903 449793",
        },
        {
          subtitle: "E-Mail",
          value: "info@schmeckt-lecker.net",
        },
      ],
    },
    {
      title: "Steuer-Nr:",
      content: [
        {
          subtitle: "",
          value: "33450462548",
        },
      ],
    },
    {
      title: "Redaktionell verantwortlich",
      content: [
        {
          subtitle: "",
          value:
            "Aydin Karabudak<br />Bahnhofstraße 40<br />59872 Meschede-Freienohl",
        },
      ],
    },
    {
      title: "EU-Streitschlichtung",
      content: [
        {
          subtitle: "",
          value:
            "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a>https://ec.europa.eu/consumers/odr/</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.",
        },
      ],
    },
    {
      title: "Verbraucherstreitbeilegung / Universalschlichtungsstelle",
      content: [
        {
          subtitle: "",
          value:
            "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen. Quelle: <a>https://www.e-recht24.de/impressum-generator.html</a>",
        },
      ],
    },
  ],
};
